import { KeyboardEventHandler, ReactNode, TextareaHTMLAttributes } from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { clsx } from 'clsx';
import { SvgCloseSearch } from '@/components/icons';
import s from './ControlledTextArea.module.scss';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  fieldName: string;
  label?: string | ReactNode;
  rules?: RegisterOptions;
}

export const ControlledTextArea = (props: Props) => {
  const {
    fieldName,
    label,
    placeholder = 'Введите',
    rules,
    disabled,
    className,
  } = props;
  const { control, resetField } = useFormContext();

  const handleKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = (e) => {
    const textarea = e.target as HTMLTextAreaElement;

    calcHeight(textarea);
  };

  const calcHeight = (elem: HTMLElement) => {
    elem.style.height = 'inherit';
    const computed = window.getComputedStyle(elem);
    const height = elem.scrollHeight + parseInt(computed.getPropertyValue('border-bottom-width'), 10) * 2;

    elem.style.height = `${height}px`;
  };

  return (
    <Controller
      control={control}
      name={fieldName}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className={clsx(s.wrapper, className, { [s.wrapper_disabled]: disabled })}>
          {label && <div className={s.wrapper__label}>{label}</div>}
          <textarea
            placeholder={placeholder}
            className={clsx(s.textarea, className, {
              [s.textarea_disabled]: disabled,
              [s.textarea_error]: error,
            })}
            value={value || ''}
            disabled={disabled}
            onKeyDown={handleKeyDown}
            onChange={(e) => {
              if (e.target.value === ' ') return;

              onChange(e.target.value);
            }}
          />
          {value && (
            <button className={clsx(s.cross, { [s.cross_shifted]: label })} type="button" onClick={() => resetField(fieldName)}>
              <SvgCloseSearch />
            </button>
          )}
          <span className={clsx(s.errorHint, { [s.errorHint_visible]: error })}>
            {error?.message}
          </span>
        </div>
      )}
    />
  );
};